import snazzyStyles from "./snazzyStyles.json";
const SITE_URL = siteVariables.site_url;
const LOCATIONS_URL = `${SITE_URL}/wp-json/dc/v1/locations`;

document.addEventListener("DOMContentLoaded", async (event) => {
	initMap();
	async function initMap() {
		const mapDiv = document.getElementById("dc-google-map");

		if (!mapDiv) return;

		const locationRes = await fetch(LOCATIONS_URL);
		if (!locationRes.ok) return;
		const locations = await locationRes.json();

		// const minLat = locations.reduce((acc, curr) => {
		// 	if (parseFloat(curr.city_latitude)) {
		// 		console.log(curr.city_latitude);
		// 		return Math.max(acc, curr.city_latitude);
		// 	}
		// 	return acc;
		// }, 0);

		// const minLng = locations.reduce((acc, curr) => {
		// 	if (parseFloat(curr.city_longitude)) {
		// 		return Math.min(acc, curr.city_longitude);
		// 	}
		// 	return acc;
		// }, Infinity);

		const [{ Map, InfoWindow }, { AdvancedMarkerElement, PinElement }] = await Promise.all([google.maps.importLibrary("maps"), google.maps.importLibrary("marker")]);

		const map = new Map(mapDiv, {
			zoom: 3.5,
			// center: { lat: parseFloat(locations[0].city_latitude), lng: parseFloat(locations[0].city_longitude) },
			center: { lat: 50.650009, lng: -90.742589 },
			mapId: "1119ffb3706595457d377d79",
		});

		locations.forEach((location) => {
			addMarker(map, location);
		});

		const infoWindow = new InfoWindow({
			minWidth: 170,
			maxWidth: 200,
		});

		map.addListener("click", function () {
			infoWindow.close();
		});

		async function addMarker(map, location) {
			if (!location.city_latitude) return;
			const pinGlyph = new PinElement({
				background: "#8ce7fd",
				glyphColor: "#3f6e8e",
				borderColor: "#8ce7fd",
				scale: 0.85,
			});
			const marker = new AdvancedMarkerElement({
				position: { lat: parseFloat(location.city_latitude), lng: parseFloat(location.city_longitude) },
				map: map,
				gmpDraggable: true,
			});
			marker.append(pinGlyph);

			marker.addListener("gmp-click", (e) => {
				marker.classList.add("bounce");
				infoWindow.close();
				infoWindow.setContent(locationContent(location));
				console.log(infoWindow.getHeaderContent());
				infoWindow.open(map, marker);
			});
		}

		function locationContent(location) {
			const content = document.createElement("div");
			content.className = "map-location-popup";
			content.innerHTML = `
			<h4>${location.city_name}</h4>
			<p>${location.city_address.replaceAll("\r\n", "<br>")}</p>
			`;
			return content;
		}
	}
});
